import { HardDrive, Network, Smartphone } from "lucide-react";
import { copy, sources } from "@/content/explordioCopy";

const DEVICES = "https://static.prod-images.emergentagent.com/jobs/299b8c53-46da-401d-aeb3-6cb3ef120270/images/fbd0c0f48d09b0503e6a10445c66c9c2958be24985041544bd0142e01e4c3114.jpeg";

const SourceIcon = ({ source }) => source === "Phone" ? <Smartphone /> : source === "NAS" || source === "SMB" ? <Network /> : <HardDrive />;

export const MediaLibrarySection = ({ onLibraryOpen }) => (
  <section className="library-section" data-testid="media-library-section">
    <div className="site-shell library-panel">
      <div className="library-copy">
        <h2 className="library-title" data-testid="media-library-title">{copy.library.title}</h2>
        <p className="library-description" data-testid="media-library-description">{copy.library.description}</p>
        <button className="learn-button" type="button" onClick={onLibraryOpen} data-testid="learn-more-button">{copy.library.action}</button>
      </div>
      <div className="source-strip" data-testid="storage-sources-list">
        {sources.map((source) => (
          <div className="source-item" key={source} data-testid={`storage-source-${source.toLowerCase().replace(" ", "-")}`}>
            <SourceIcon source={source} /><span>{source}</span>
          </div>
        ))}
      </div>
      <img className="storage-devices" src={DEVICES} alt="Explordio storage locations on phone and tablet" data-testid="storage-devices-image" />
    </div>
  </section>
);